import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=d5a87390&scoped=true&"
import script from "./scale.vue?vue&type=script&lang=js&"
export * from "./scale.vue?vue&type=script&lang=js&"
import style0 from "./scale.vue?vue&type=style&index=0&id=d5a87390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a87390",
  null
  
)

export default component.exports